import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchOrganizationLocations } from '../../addvehicle/AddVehicleActions';
import { useLocationIdCookie } from './useLocationIdCookie';

const useDefaultBidLocationId = () => {
  const dispatch = useDispatch();
  const organizationLocations = useSelector((state) =>
    state.myOrganization.get('organizationLocations'),
  );
  const cookieId = useLocationIdCookie();

  useEffect(() => {
    if (!Array.isArray(organizationLocations) || organizationLocations.length === 0) {
      dispatch(fetchOrganizationLocations());
    }
  }, [dispatch, organizationLocations]);

  return useMemo(() => {
    const locations = Array.isArray(organizationLocations) ? organizationLocations : [];
    if (locations.length === 0) {
      return null;
    }
    const byCookie = locations.find((loc) => loc.id === cookieId);
    const main = locations.find((loc) => loc.isMain);
    return (byCookie || main || locations[0])?.id ?? null;
  }, [organizationLocations, cookieId]);
};

export default useDefaultBidLocationId;
